import React, { useEffect, useState } from "react";
import Sidebaar from "../Component/Sidebar";
import TitleComp from "../Component/TitleComp";
import { Bars } from "react-loader-spinner";
import { Button, Col, Form, FormGroup, Modal } from "react-bootstrap";
import axios from "axios";
import { Base_Url } from "../BaseUrl";
import { Box } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { ToastContainer, toast } from "react-toastify";
import { compressImage } from "../Component/CompressImage";

function Slider() {
  const [loading, setloading] = useState(false);
  const [file, setfile] = useState("");
  const [position, setposition] = useState("");
  const [data, setdata] = useState([]);
  const [editimg, seteditimg] = useState("");
  const [id, setid] = useState("");

  let token = localStorage.getItem("token");
  const headers = {
    Authorization: `Bearer ${token}`,
  };

  const [imageurl, setimageurl] = useState("")


  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = (e, value) => {
    setShow(true)
    setimageurl(value)
  };

  const handleget = () => {
    setloading(true);
    axios.get(`${Base_Url}/sliders`, { headers }).then((res) => {
      setdata(res.data.data);
      if (res.data != null) {
        setloading(false);
      }
    });
  };

  const handlefile = (e) => {
    e.preventDefault();
    let selectedfile = e.target.files[0];
    setfile(selectedfile);
  };

  // const handleSubmit = (e) => {
  //   setloading(true);
  //   e.preventDefault();
  //   let formdata = new FormData();
  //   formdata.append("image", file);
  //   formdata.append("position", position);
  //   if (id) {
  //     formdata.append("_id", id);
  //     axios.put(`${Base_Url}/sliders`, formdata, { headers }).then((res) => {
  //       if (res.data !== null) {
  //         setloading(false);
  //         handleget();
  //         seteditimg("");
  //       }
  //     });
  //   } else {
  //     axios.post(`${Base_Url}/sliders`, formdata, { headers }).then((res) => {
  //       if (res.data !== null) {
  //         setloading(false);
  //         handleget();
  //       }
  //     });
  //   }
  // };

  const handleSubmit = (e) => {
    setloading(true);
    e.preventDefault();
    let formdata = new FormData();
    compressImage(file).then((compressedFile) => {
      formdata.append("image", compressedFile);
      formdata.append("position", position);
      if (id) {
        formdata.append("_id", id);
        axios.put(`${Base_Url}/sliders`, formdata, { headers }).then((res) => {
          if (res.data !== null) {
            setloading(false);
            handleget();
            seteditimg("");
          }
        });
      } else {
        axios.post(`${Base_Url}/sliders`, formdata, { headers }).then((res) => {
          if (res.data !== null) {
            setloading(false);
            handleget();
          }
        });
      }
    });
  };
  

  const handleedit = (e, id) => {
    e.preventDefault();
    setid(data[id]._id);
    setposition(data[id].position);
    seteditimg(data[id].image);
  };

  const getRowId = (row) => row._id;
  const columns = [
    { field: "position", headerName: "Position", flex: 1 },

    {
      field: "image",
      headerName: "image",
      flex: 1,
      renderCell: (params) => {
        const { value } = params;
        return (
          <img
            src={`${Base_Url}/${value}`}
            onClick={(e)=>handleShow(e, value)}
            style={{
              
              width: "45px",
              height: "45px",
              borderRadius: "50%",
            }}
            alt="value"
            className="img-fluid tableimgmui"
          ></img>
        );
      },
    },

    {
      field: "edit",
      headerName: "Edit",
      flex: 1,
      renderCell: (params) => {
        const index = params.row.index;
        return (
          <span
            style={{ cursor: "pointer" }}
            onClick={(e) => handleedit(e, index)}
          >
            <i className="fa-solid fa-pen-to-square"></i>
          </span>
        );
      },
    },
    {
      field: "delete",
      headerName: "Delete",
      flex: 1,
      renderCell: (params) => {
        const index = params.row.index;
        const id = params.row._id; // Corrected to rowIndex
        return (
          <span
            style={{ cursor: "pointer" }}
            onClick={(e) => {
              handleDelete(e, id);

            }}
          >
            <i class="fa-solid fa-trash"></i>
          </span>
        );
      },
    },
  ];


  const notify = (message, type) => {
    // console.log("type", type);
    toast[type](message, {
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  };



  const handleDelete = (e, id) => {
    e.preventDefault();

    let requestdata = {
      _id: id,
      deleted_at: Math.floor(Date.now() / 1000),
    };

    axios
      .put(`${Base_Url}/sliders`, requestdata, { headers })
      .then((res) => {
        // console.log(res);
        if (res.data.message === "Ok") {
          handleget();
          notify("Delete Successfully", "success");
          // console.log("Data", res.data);
        }
      })
      .catch((error) => {
        console.error("Error deleting:", error);
        notify("Error deleting", "error");
      });
  };

  useEffect(() => {
    handleget();
  }, []);

  return (
    <>
      {loading && (
        <div className="overlay">
          <Bars
            height="80"
            width="80"
            color="#051322"
            ariaLabel="bars-loading"
            visible={true}
          />
        </div>
      )}
      <Sidebaar
        content={
          <>
            <TitleComp title="Slider" />
            <Form onSubmit={handleSubmit} className="mt-3">
              <div className="row gy-5 align-items-center">
                {editimg && (
                  <Col md="1">
                    <img
                      src={`${Base_Url}/${editimg}`}
                      className="img-fluid rounded-3 w-100"
                      alt="editimage"
                    />
                  </Col>
                )}
                <div className="col-md-4">
                  <FormGroup>
                    <label htmlFor="">Image</label>
                    <input
                      type="file"
                      onChange={handlefile}
                      className="form-control"
                    />
                  </FormGroup>
                </div>
                <div className="col-md-4">
                  <FormGroup>
                    <label htmlFor="">Position</label>
                    <input
                      type="number"
                      className="form-control"
                      value={position}
                      onChange={(e) => setposition(e.target.value)}
                    />
                  </FormGroup>
                </div>
                <div className="col-md-2">
                  <button className="btn bg-dark mt-3 text-white">
                    Submit
                  </button>
                </div>
                <Col md="12">
                  <Box sx={{ height: 500, width: "100%" }}>
                    <DataGrid
                      //   rows={data} // Update this line
                      rows={data.map((row, index) => ({
                        ...row,
                        index,
                      }))}
                      columns={columns}
                      pageSize={5}
                      getRowId={getRowId}
                      initialState={{
                        pagination: { paginationModel: { pageSize: 10 } },
                      }}
                      pageSizeOptions={[5, 10, 25]}
                    />
                  </Box>
                </Col>
              </div>
            </Form>
            <ToastContainer />
            <Modal show={show} size="md" onHide={handleClose}>
              <Modal.Header closeButton>
                <Modal.Title>Image</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <img src={`${Base_Url}/${imageurl}`} alt="" />
              </Modal.Body>
              <Modal.Footer>
                <Button className="text-write bg-secondary  shadow-none border-0" onClick={handleClose}>
                  Close
                </Button>
              </Modal.Footer>
            </Modal>
          </>
        }
      />
    </>
  );
}

export default Slider;
